<template>
  <div class="feature mt-h">
    <feature-tittle></feature-tittle>
    <feature-content :featureList='featureList'></feature-content>
    <back-top></back-top>
  </div>
</template>

<script>
import FeatureTittle from "./featurechild/FeatureTittle.vue";
import FeatureContent from "./featurechild/FeatureContent.vue";
import BackTop from "@/components/common/backtop/BackTop.vue";
import { getHomeFeature } from "@/network/home.js";
export default {
  name: "Feature",
  components: {
    FeatureTittle,
    FeatureContent,
    BackTop
  },
  data(){
    return{
      featureList:[],
    }
  },
  mounted(){
    document.title = 'COLUMN | ShanghaiEye';
    this.getFeatureList();
  },
  methods:{
    getFeatureList(){
      getHomeFeature().then(res=>{
        this.featureList = res.data;
      })
    }
  }
};
</script>

<style lang="less">
.feature {
}
</style>